<template>
  <v-list-item-title>
    <div>
    <SectionChip  class="mr-3"   :item="item"/>
    <span style="color:black">
      {{ item.properties.name }}
      </span>
    </div>
    <NumberOfSchematisationChip :number-of-schematisation="numberOfSchematisation">

    </NumberOfSchematisationChip>

  </v-list-item-title>
</template>
<script>
import SectionChip from "@/components/dikeSection/SectionChip.vue";
import ProfileChip from "@/components/dike/ProfileChip.vue"
import NumberOfSchematisationChip from "@/components/dikeProfile/NumberOfSchematisationChip.vue"

export default {
  name: 'DikeSectionIndexTitle',
  components: { NumberOfSchematisationChip, ProfileChip, SectionChip},
  props: {
    item: {},
    name: {required: false, default: false},
    numberOfSchematisation: { type: Number, default: 0},
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style scoped>

.v-list-item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: 500;
  color: black;
}

</style>
